module.exports = __webpack_public_path__ + "assets/img/mobileCard2.2f3cad31.png";